// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__pf1RR","col":"styles_col__TLY-H"};